import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

const EMPTY = { new_email: "", new_password: "", confirm: "", current_password: "" };

export const AccountDialog = ({ open, onOpenChange }) => {
  const { user, updateAccount } = useAuth();
  const [f, setF] = useState(EMPTY);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!f.new_email && !f.new_password) return setError("Enter a new email or a new password");
    if (f.new_password && f.new_password !== f.confirm) return setError("New passwords do not match");
    setBusy(true);
    try {
      await updateAccount({ current_password: f.current_password, new_email: f.new_email || null, new_password: f.new_password || null });
      toast.success("Account updated");
      setF(EMPTY);
      onOpenChange(false);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) { setF(EMPTY); setError(""); } }}>
      <DialogContent aria-describedby={undefined} className="rounded-none sm:max-w-md" data-testid="account-dialog">
        <form onSubmit={submit} className="space-y-4">
          <DialogHeader><DialogTitle className="font-display">My Account</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-c">Signed in as <span className="text-ink font-medium" data-testid="account-current-email">{user?.email}</span></p>
          <div>
            <Label>New email (optional)</Label>
            <Input type="email" value={f.new_email} onChange={set("new_email")} className="mt-1 rounded-none" data-testid="account-new-email-input" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>New password</Label>
              <Input type="password" minLength={6} value={f.new_password} onChange={set("new_password")} className="mt-1 rounded-none" data-testid="account-new-password-input" />
            </div>
            <div>
              <Label>Confirm</Label>
              <Input type="password" value={f.confirm} onChange={set("confirm")} className="mt-1 rounded-none" data-testid="account-confirm-password-input" />
            </div>
          </div>
          <div>
            <Label>Current password (required)</Label>
            <Input type="password" required value={f.current_password} onChange={set("current_password")} className="mt-1 rounded-none" data-testid="account-current-password-input" />
          </div>
          {error && <p className="text-sm text-neg" data-testid="account-error">{error}</p>}
          <DialogFooter>
            <Button type="submit" disabled={busy} className="rounded-none w-full bg-brand hover:bg-brand/90 text-onbrand" data-testid="account-save-button">
              {busy ? "Saving…" : "Save changes"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
